import {
	Button,
	Card,
	CardContent,
	createStyles,
	Dialog,
	DialogActions,
	DialogContent,
	type DialogProps,
	DialogTitle,
	Grid,
	makeStyles,
	Typography,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useMapContext } from "../context/MapContext";
import type { AssetFromMap } from "../models/AssetFromMap";

const useStyles = makeStyles((theme) =>
	createStyles({
		root: {
			"& .input-group-text": {
				display: "none",
			},
		},
		messageTitle: {
			fontSize: 15,
			fontWeight: "bold",
			color: "#0000008A",
		},
	}),
);

type Props = {
	show: boolean;
	onHide: (onHide: boolean) => void;
};

export const HiddenChildrenDialog = ({ show, onHide }: Props) => {
	const classes = useStyles();
	const [fullWidth, setFullWidth] = useState(true);
	const [maxWidth, setMaxWidth] = useState<DialogProps["maxWidth"]>("md");
	const navigate = useNavigate();

	const {
		state: { assetChildrensFromApi, hiddenChildrenList, listHiddenChildrenIds },
		actions: { setHiddenChildrenList, setCurrAssetId },
	} = useMapContext();
	const handleCancel = () => {
		onHide(false);
	};

	const handleNavigateToAsset = (assetChildren: any) => {
		if (assetChildren.ChildrenCount == 0)
			navigate(
				`/asset-details/${assetChildren.AssetId}?resource=drawings&assets=true&statistics=true&workOrders=true`,
			),
				{ replace: true };
		else setCurrAssetId(assetChildren.AssetId);
		handleCancel();
	};

	useEffect(() => {
		if (show) {
			const listAssetsChildrenHiden = assetChildrensFromApi.filter(
				(assetChildren: any) => {
					return listHiddenChildrenIds.some(
						(assetChildrenHidden: AssetFromMap) =>
							assetChildren.AssetId === assetChildrenHidden,
					);
				},
			);
			setHiddenChildrenList(listAssetsChildrenHiden);
		}
	}, [show]);

	return (
		<>
			<Dialog
				fullScreen={true}
				fullWidth={fullWidth}
				maxWidth={maxWidth}
				style={{ margin: "20px 40px" }}
				open={show}
				onClose={() => handleCancel()}
			>
				<Grid container style={{ height: "100%", padding: "0" }}>
					<Grid item md={12} xs={12} style={{ margin: "auto 0" }}>
						<DialogTitle>HIDDEN CHILDREN</DialogTitle>
					</Grid>
					<Grid container item>
						<DialogContent dividers>
							<Grid container style={{ height: "61vh" }}>
								<Grid item md={12} xs={12} style={{ height: "100%" }}>
									<Card
										variant="outlined"
										style={{
											height: "105%",
											backgroundColor: "#E9F2F8",
											alignItems: "center",
										}}
									>
										<CardContent
											style={{ height: "100%", overflowY: "scroll" }}
										>
											<Typography className={classes.messageTitle}>
												ASSET :
											</Typography>
											{hiddenChildrenList.map((assetChildren: any) => {
												return (
													<Typography
														onClick={() => handleNavigateToAsset(assetChildren)}
														style={{ cursor: "pointer" }}
													>
														<span
															style={{ fontWeight: "bolder", fontSize: "20px" }}
														>
															{assetChildren.AssetName}:{" "}
														</span>
														PM Open Orders:{" "}
														<span style={{ fontWeight: "bolder" }}>
															{assetChildren.PMWorkOrdersChildren}{" "}
														</span>
														- RM Open Orders:{" "}
														<span style={{ fontWeight: "bolder" }}>
															{assetChildren.RMWorkOrdersChildren}{" "}
														</span>
														- Close Orders:{" "}
														<span style={{ fontWeight: "bolder" }}>{`${
															((assetChildren.PMWorkOrdersChildrenClosed! as number) +
																assetChildren.PMWorkOrdersChildrenClosed!) as number
														}`}</span>
													</Typography>
												);
											})}
										</CardContent>
									</Card>
								</Grid>
							</Grid>
						</DialogContent>
					</Grid>

					<Grid
						item
						md={12}
						xs={12}
						style={{ padding: "10px 0 15px", margin: "auto 0" }}
					>
						<DialogActions style={{ padding: "0px 24px" }}>
							<Grid item md={3} xs={12} style={{ marginRight: "0" }}>
								<Button
									fullWidth
									variant="contained"
									color="default"
									onClick={handleCancel}
								>
									Close
								</Button>
							</Grid>
						</DialogActions>
					</Grid>
				</Grid>
			</Dialog>
		</>
	);
};
